import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const BackdropLoading = ({ open, handleCloseLoader }) => {
  return (
    <>
      <Backdrop
        sx={{ color: "white", zIndex: theme => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleCloseLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default BackdropLoading;
